<div id="slideOut" [class.showSlideOut]="isOpen">
    <!--   // Tab -->
    <div class="slideOutTab btn-info" (click)="isOpen = !isOpen">
        <div>
            <i class="ft-search font-medium-2"></i>
        </div>
    </div>
    <div class="modal-content">
        <div class="modal-body">
            <section>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body ">
                            <form (ngSubmit)="getList()" [formGroup]="listForm" class="full-width ">
                                <div class="form-row">
                                    <div class="col-md-3 mb-1 form-group">
                                        <label for="Code">Employee Code</label>
                                        <input type="text" formControlName="Code" name="Code" class="form-control" id="Code" placeholder="Employee Code">
                                    </div>
                                    <div class="col-md-3 mb-1 form-group">
                                        <label for="FirstName">First Name</label>
                                        <input type="text" formControlName="FirstName" name="FirstName" class="form-control" id="FirstName" placeholder="First Name">
                                    </div>
                                    <div class="col-md-3 mb-1 form-group">
                                        <label for="LastName">Last Name</label>
                                        <input type="text" formControlName="LastName" name="LastName" class="form-control" id="LastName" placeholder="Last Name">
                                    </div>
                                    <div class="col-md-3 mb-1 form-group">
                                        <label for="MobileNumber">Mobile No</label>
                                        <input type="text" formControlName="MobileNumber" name="MobileNumber" class="form-control" id="MobileNumber" placeholder="Mobile No">
                                    </div>
                                    <div class="col-md-3 mb-1 form-group">
                                        <label for="ReferenceCode">Reference Code</label>
                                        <input type="text" formControlName="ReferenceCode" name="ReferenceCode" class="form-control" id="ReferenceCode" placeholder="Reference Code">
                                    </div>

                                    <div class="col-md-9 mb-1 form-group ">
                                        <button class="btn btn-sm btn-custom ml-1 mb-1 w-85px ClearFormContent pull-right" type="button" (click)="reset()">
                                            <i class="ft-x-circle mr-1"></i>
                                            Clear</button>
                                        <button class="btn btn-sm btn-info mr-1 mb-1 w-85px pull-right" type="submit">
                                            <i class="ft-search mr-1"></i>Search</button>

                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body ">
                            <div class="row">
                                <div class="col-12">
                                    <form>
                                        <div class="d-flex justify-content-between p-2 pull-left">
                                            <ngb-pagination [collectionSize]="_total$  | async" [maxSize]="3" [rotate]="true" [(page)]="pageIndex" [pageSize]="pageSize" (pageChange)="getList()">
                                                <ng-template ngbPaginationPrevious>Prev</ng-template>
                                                <ng-template ngbPaginationNext>Next</ng-template>
                                            </ngb-pagination>

                                        </div>

                                        <div class="table-responsive" id="htmlData" #htmlData>
                                            <table class="table table-striped" id="exceltable" #exceltable>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Code</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Location</th>
                                                        <th scope="col">Department</th>
                                                        <th scope="col">Company</th>
                                                        <th scope="col">Status</th>
                                                        <th scope="col">Reference Code</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of _dataSoruces$  | async;let i = index">
                                                        <th scope="row">{{item.Code}}</th>
                                                        <th scope="row">{{item.EmployeeName}}</th>
                                                        <th scope="row">{{item.Location}}</th>
                                                        <th scope="row">{{item.ODTitle}}</th>
                                                        <th scope="row">{{item.ECMTitle}}</th>
                                                        <th scope="row">{{item.Status}}</th>
                                                        <th scope="row">{{item.ReferenceCode}}</th>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>


                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>